import UserActions from 'actions/UserActions';
import UserSource from 'sources/UserSource';

export const UserSourceAsyncStoreConfig = {
  /**
   * Fetch `User` objects for a couple `userIds` values
   * @param  {array(string)} userIds An array of userId strings
   * @return {Promise} A promise whose `resolve` and `reject` return the data to the promise resolver
   */
  fetch: {
    remote(state, userIds) {
      return UserSource.fetchAll({ids: userIds});
    },
    success: UserActions.fetchSuccess,
    error: UserActions.fetchError,
  },
};
